import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/qualityControlReport',
    meta: { title: '批检品控报告' },
    component: Layout,
    redirect: '/qualityControlReport/list',
    children: [
      {
        path: 'list',
        meta: { title: '批检品控报告', activeMenu: '/qualityControlReport' },
        component: () => import('@/views/qualityControlReport/QualityControlReport.vue')
      },
      {
        path: 'detail',
        meta: { title: '批检品控报告详情', activeMenu: '/qualityControlReport' },
        component: () => import('@/views/qualityControlReport/QualityControlReportDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增批检品控报告', activeMenu: '/qualityControlReport' },
        component: () => import('@/views/qualityControlReport/QualityControlReportAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑批检品控报告', activeMenu: '/qualityControlReport' },
        component: () => import('@/views/qualityControlReport/QualityControlReportAdd.vue')
      }

    ]
  }

]
